import React from 'react';
import Banner from '@deporvillage/banner-geo-ip-component';
import PropTypes from 'prop-types';

import styles from './BannerGeoIp.module.scss';

const BannerType = {
    Delivery: 1,
    Store: 2,
};

const BannerGeoIp = ({
    type, url, extension, country,
}) => (
    <div className={styles['banner-geo-ip-component']}>
        <Banner type={type} url={url} extension={extension} country={country} />
    </div >
);

BannerGeoIp.propTypes = {
    type: PropTypes.oneOf([BannerType.Delivery, BannerType.Store]),
    url: PropTypes.string,
    country: PropTypes.string,
    extension: PropTypes.string,
};

export default BannerGeoIp;
export { BannerType as BannerGeoIpType };
